module.exports = __webpack_public_path__ + "static/media/backTranslation.440eafab.gif";